import { BAR_GAP, DEFAULT_SINGLE_BAR_WIDTH } from "..";
import { CONTAINER_PADDING } from "../styled";

export const divideBarIntoEqualParts = (num) => {
    if (num <= 100) return num;
    if (num <= 200) return 200;
    if (num <= 500) return 500;
    if (num <= 1000) return 1000;
    const magnitude = Math.pow(10, Math.floor(Math.log10(num)));
    return Math.ceil(num / magnitude) * magnitude;
};

export const useGetDimensions = (data, maxHeight, containerWidth, totalDataCount, highestCount) => {
    let singleBarWidth;

    const totalBars = data?.reduce((total, tagCategory ) => {
            return total += tagCategory.tagSpecificCount?.length
        }
    ,0)

    const totalGapSpace = (totalBars - 1) * Math.floor(BAR_GAP * 10); // BAR GAP, example 0.3 converted 3Px

    const availableWidthForBars = (containerWidth - totalGapSpace) - (CONTAINER_PADDING * 2); // CONTAINER_PADDING Left right 10 * 10  = 20

    // const defaultWidthForBars = (totalBars - 1) * DEFAULT_SINGLE_BAR_WIDTH - (CONTAINER_PADDING * 2);
    
    const dynamicBarWidth = availableWidthForBars / totalBars;

    singleBarWidth = Math.max(dynamicBarWidth, DEFAULT_SINGLE_BAR_WIDTH);

    // Calculate the ceiling value for the highest count


    const barSections = divideBarIntoEqualParts(highestCount);

    return data?.map(category => {
        // total count for this category
        const total = category.tagSpecificCount.reduce((sum, tag) => sum + tag.count, 0);

        const barsInCategory = category.tagSpecificCount.length;
        const gapsInCategory = Math.max(0, barsInCategory - 1); // One less gap than bars

        const categoryTotalWidth = (barsInCategory * singleBarWidth) + (gapsInCategory * Math.floor(BAR_GAP * 10));
        
        // percentage to each tag
        return {
            ...category,
            width: categoryTotalWidth,
            tagSpecificCount: category.tagSpecificCount.map(tag => {
                // Original percentage relative to total dataset
                let percentage = Number((tag.count / (totalDataCount || total) * 100).toFixed(1));
                
                // New height calculation relative to highest count and ceiling
                // This creates a "zoomed in" effect where bars are more visible
                const relativeHeight = Math.round((tag.count / barSections) * maxHeight);
                
                return{
                   percentage: percentage,  // Keep original percentage for reference
                   height: relativeHeight, // New height based on relative scaling
                   width: singleBarWidth,
                   barSections: barSections,
                   ...tag,
                }
              }
            )
        };
    });
}
